const millisecondsInMinute = 60000;
const millisecondsInAnHour = 3600000;
const millisecondsInADay = 86400000;
const millisecondsInAWeek = 604800000;

export const calculateRelativeTime = (timeStr: string, locale: string) => {
	const date = new Date(timeStr);
	let millisecondsSince = Math.floor(new Date().getTime() - date.getTime());

	const isPostScheduled = millisecondsSince < 0;

	if (isPostScheduled) {
		millisecondsSince = Math.abs(millisecondsSince);
	}

	if (millisecondsSince < millisecondsInMinute) {
		// Return the time in seconds if it's less than a minute
		const secondsSince = Math.floor(millisecondsSince / 1000);
		return new Intl.RelativeTimeFormat(locale).format(
			isPostScheduled ? secondsSince : -secondsSince,
			'second'
		);
	} else if (millisecondsSince < millisecondsInAnHour) {
		// Return the time in minutes if it's less than an hour
		const minutesSince = Math.floor(millisecondsSince / millisecondsInMinute);
		return new Intl.RelativeTimeFormat(locale).format(
			isPostScheduled ? minutesSince : -minutesSince,
			'minute'
		);
	} else if (millisecondsSince <= millisecondsInADay) {
		// Return the time in hours if it's less than a day
		const hoursSince = Math.floor(millisecondsSince / millisecondsInAnHour);
		return new Intl.RelativeTimeFormat(locale, { style: 'short' }).format(
			isPostScheduled ? hoursSince : -hoursSince,
			'hour'
		);
	} else if (millisecondsSince <= millisecondsInAWeek || isPostScheduled) {
		// Return the time in days if it's less than a week
		const daysSince = Math.floor(millisecondsSince / millisecondsInADay);
		return new Intl.RelativeTimeFormat(locale, { style: 'short' }).format(
			isPostScheduled ? daysSince : -daysSince,
			'day'
		);
	} else {
		// Return the date if it's more than a week in the format 'jan 1, 2020'
		return new Intl.DateTimeFormat(locale, {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		}).format(date);
	}
};
